import React from 'react'
import { SelectProps } from 'antd'
import CtxScenarioIconSelect from './CtxScenarioIconSelect'

const CtxScenarioLockSelect = (props: SelectProps) => {
  return <CtxScenarioIconSelect {...props} disableLocked />
}

export default CtxScenarioLockSelect
